import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

/**
 * custom paginator for i18n translation
 *
 * component miros the original compoent,
 * but provides a extended way to translate helper texts
 */
@Injectable()
export class CustomPaginator extends MatPaginatorIntl {
    /** overwrites for helper texts */
    override itemsPerPageLabel = $localize`:@@paginator-item-perpage:Items per page`;
    /** paging button helper texts */
    override nextPageLabel = $localize`:@@paginator-next-page:Next page`;
    override previousPageLabel = $localize`:@@paginator-previous-page:Previous page`;
    override lastPageLabel = $localize`:@@paginator-last-page:Last page`;
    override firstPageLabel = $localize`:@@paginator-first-page:First page`;

    /**
     * overrite for page ranges
     * @param {number} page - page
     * @param {number} pageSize - pageSize
     * @param {number} length - length
     * @returns {string} - calculated text respresentation
     */
    override getRangeLabel = function (page: number, pageSize: number, length: number) {
        if (length === 0 || pageSize === 0) {
            return $localize`:@@paginator-range-start:0 of` + ' ' + length;
        }
        length = Math.max(length, 0);

        const startIndex = page * pageSize;
        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        const hintLength = $localize`:@@paginator-range-length:of`;

        return `${startIndex + 1} - ${endIndex} ${hintLength} ` + length;
    };
}
